/**
 * @generated SignedSource<<4f1644969f31fe86549b2e200ca3407d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUScreenQuery$variables = {
  includeHidden?: boolean | null;
  teamId: string;
};
export type PLUScreenQuery$data = {
  readonly store: {
    readonly team: {
      readonly allCategories: ReadonlyArray<{
        readonly products: ReadonlyArray<{
          readonly active: boolean;
          readonly eanCode: string | null;
          readonly id: string;
          readonly pluCode: string | null;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
        }>;
      }>;
      readonly pluCategories: ReadonlyArray<{
        readonly color: string;
        readonly id: string;
        readonly products: ReadonlyArray<{
          readonly active: boolean;
          readonly eanCode: string | null;
          readonly id: string;
          readonly pluCode: string | null;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
        }>;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"PLUCategoryItem_PLUCategory">;
      }>;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureInTier_Store" | "usePermissions_store">;
  };
};
export type PLUScreenQuery = {
  response: PLUScreenQuery$data;
  variables: PLUScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHidden"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "includeHidden",
    "value": true
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eanCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pluCode",
  "storageKey": null
},
v9 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PLUProductItem_PLUProduct"
},
v10 = [
  {
    "kind": "Variable",
    "name": "includeHidden",
    "variableName": "includeHidden"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eanType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PLUCategory",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v11/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlExpiresAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbhash",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usePermissions_store"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHasFeatureInTier_Store"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": "allCategories",
                "args": (v3/*: any*/),
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "pluCategories(includeHidden:true)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PLUCategoryItem_PLUCategory"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PLUScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myPermissions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              {
                "alias": "allCategories",
                "args": (v3/*: any*/),
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": "pluCategories(includeHidden:true)"
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "pluCategories",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72e3da3871714329e6b401f7c697d3cc",
    "id": null,
    "metadata": {},
    "name": "PLUScreenQuery",
    "operationKind": "query",
    "text": "query PLUScreenQuery(\n  $teamId: ID!\n  $includeHidden: Boolean\n) {\n  store {\n    ...usePermissions_store\n    ...useHasFeatureInTier_Store\n    team(id: $teamId) {\n      allCategories: pluCategories(includeHidden: true) {\n        products {\n          title\n          id\n          active\n          eanCode\n          pluCode\n          ...PLUProductItem_PLUProduct\n        }\n        id\n      }\n      pluCategories(includeHidden: $includeHidden) {\n        id\n        title\n        color\n        ...PLUCategoryItem_PLUCategory\n        products {\n          id\n          title\n          active\n          eanCode\n          pluCode\n          ...PLUProductItem_PLUProduct\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment PLUCategoryItem_PLUCategory on PLUCategory {\n  id\n  title\n  color\n}\n\nfragment PLUProductItemBody_PLUProduct on PLUProduct {\n  id\n  title\n  active\n  category {\n    ...PLUProductItemCategoryTag_PLUCategory\n    id\n  }\n  imageUrl\n  image {\n    id\n    sizes {\n      width\n      id\n    }\n    ...Image_image\n  }\n}\n\nfragment PLUProductItemCategoryTag_PLUCategory on PLUCategory {\n  id\n  color\n  title\n}\n\nfragment PLUProductItemFooter_PLUProduct on PLUProduct {\n  pluCode\n  eanCode\n  eanType\n}\n\nfragment PLUProductItem_PLUProduct on PLUProduct {\n  id\n  ...PLUProductItemFooter_PLUProduct\n  ...PLUProductItemBody_PLUProduct\n}\n\nfragment useHasFeatureInTier_Store on Store {\n  tier\n}\n\nfragment usePermissions_store on Store {\n  id\n  myPermissions\n}\n"
  }
};
})();

(node as any).hash = "6831564176e9a68894093833a19437bb";

export default node;
